export enum ArrowSpinnerColour {
  BRAND_AQUA = 'Aqua',
  BRAND_BLACK_GRAPE = 'Black Grape',
  BRAND_BERRY = 'Berry',
  WHITE = 'White',
  BRAND_MONO_ONE = 'Mono 1',
}
